// Copyright (c) 2026 Goffy. This file belongs to Goffy. All Rights Reserved.

export const appColors = {
  background: {
    app: '#011806',
    panel: '#07200D',
    panelAlt: '#0C2510',
    elevated: '#123018',
    interactive: '#A1D493',
    interactiveMuted: '#2A4A2F',
  },
  surface: {
    base: '#07200D',
    alt: '#0C2510',
    elevated: '#123018',
    input: '#0D2A13',
    muted: '#183520',
  },
  text: {
    primary: '#F5F5DC',
    secondary: '#C8C8B0',
    muted: '#8FA08B',
    heading: '#F5F5DC',
    inverse: '#011806',
  },
  border: {
    default: 'rgba(22,47,26,0.15)',
    strong: '#1A3A20',
    accent: '#A1D493',
  },
  accent: {
    primary: '#A1D493',
    positive: '#A1D493',
    subtleBg: '#0C2510',
    subtleBorder: 'rgba(161,212,147,0.3)',
    overlay: 'rgba(1,24,6,0.5)',
  },
  status: {
    danger: '#d73f4e',
    dangerStrong: '#bf2634',
    warning: '#a66f11',
    success: '#A1D493',
  },
  button: {
    primaryBg: '#A1D493',
    primaryBorder: '#A1D493',
    primaryText: '#011806',
    secondaryBg: '#0C2510',
    secondaryBorder: '#1A3A20',
    secondaryText: '#F5F5DC',
    ghostBg: 'transparent',
    ghostBorder: '#1A3A20',
    ghostText: '#C8C8B0',
  },
} as const;

export default appColors;
